import { ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Impressum from "./pages/Impressum/Impressum";
import Datenschutz from "./pages/Datenschutz/Datenschutz";
import Quiz from "./pages/Quiz/Quiz";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import CookieConsent from "./components/CookieConsent/CookieConsent";
import { CookieConsentProvider } from "./contexts/CookieConsentContext";
import { hsvTheme } from "./theme/theme";

const queryClient = new QueryClient();

const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={hsvTheme}>
                <CookieConsentProvider>
                    <Router>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/impressum" element={<Impressum />} />
                            <Route
                                path="/datenschutz"
                                element={<Datenschutz />}
                            />
                            <Route path="/quiz" element={<Quiz />} />
                        </Routes>
                        <CookieConsent />
                    </Router>
                </CookieConsentProvider>
            </ThemeProvider>
        </QueryClientProvider>
    );
};

export default App;
